import axiosClass from "./axios";
import baseClass from "./base";

function processDataObject(obj, val) {
  var infoparser = obj.attr("data-infoparser");
  infoparser = infoparser != undefined ? JSON.parse(infoparser) : false;
  infoparser =
    val && infoparser && infoparser[val] != undefined ? infoparser[val] : false;

  var params = [
    "remove",
    "showurl",
    "hideurl",
    "redirecturl",
    "redirecttype",
    "inbackground",
    "redirecttargetid",
    "updateurl",
    "href",
    "targetid",
    "toggleinfo",
    "toggleclassinfo",
    "toggleclassinfoclassname",
    "removeclassinfo",
    "removeclassinfoclassname",
    "hideinfo",
    "showinfo",
    "classshow",
    "classshide",
    "classinfo",
    "submit",
    "stopother",
    "click",
    "alert",
    "changehtml",
    "htmlvalue",
    "changeattr",
    "removeattr",
  ];

  var rez = {};
  for (var i in params) {
    var t = params[i];
    var tv = obj.attr("data-" + t);

    tv = tv != undefined ? tv : infoparser[t] != undefined ? infoparser[t] : tv;
    rez[t] = tv;
  }

  rez["specval"] = infoparser ? "" : val;
  return rez;
}

function processCustomRedirect(obj, objParams, field) {
  field = field != undefined ? field : "redirecturl";

  var rd = objParams[field];

  if (rd != undefined) {
    rd += objParams.specval;
    
    var inbackground = objParams.inbackground != undefined ? objParams.inbackground : 0;
    var type = objParams.redirecttype != undefined ? objParams.redirecttype : "simple";
    var targetid = objParams.redirecttargetid != undefined
        ? objParams.redirecttargetid
        : "main";

    if (type == "simple") {
      window.location.href = rd;
    }
    
    var tobj = {};
    tobj.href = rd;
    tobj.targetid = targetid;
    tobj.inbackground = inbackground;
    tobj.type = type;

    baseClass.loadDataAjax(undefined, tobj);
  }
}

function customaction(obj, val, ischecked) {
  val = val != undefined ? val : "";
  ischecked = ischecked != undefined ? ischecked : true;

  var objParams = processDataObject(obj, val);


  // ---------------------------

  if (objParams.classinfo == undefined) var classobj = obj;
  else var classobj = $(objParams.classinfo);

  if (objParams.changehtml != undefined) {
    const htmlvalue =
      objParams.htmlvalue != undefined ? objParams.htmlvalue : "";
    $(objParams.changehtml).html(htmlvalue);
  }

  if (objParams.remove != undefined) {
    $(objParams.remove).remove();
  }

  processCustomRedirect(obj, objParams);

  if (objParams.updateurl != undefined) {
    objParams.updateurl += objParams.specval;
    axiosClass.updateElements(objParams.updateurl);
  }

  if (objParams.href != undefined) {
    baseClass.loadDataAjax(obj, objParams);
    axiosClass.updateElements(objParams.updateurl);
  }

  if (objParams.toggleinfo != undefined) {
    $(objParams.toggleinfo + objParams.specval).each(function () {
      $(this).toggle();

      const isVisible = $(this).is(':visible');
      const f = (isVisible) ? 'showurl' : 'hideurl';
      processCustomRedirect(obj, objParams, f);

      if (objParams.classshow != undefined) {
        if ($(this).is(":visible")) classobj.addClass(objParams.classshow);
        else classobj.removeClass(objParams.classshow);
      }
      if (objParams.classshide != undefined) {
        if ($(this).is(":hidden")) classobj.addClass(objParams.classshide);
        else classobj.removeClass(objParams.classshide);
      }
    });
  }

  if (objParams.toggleclassinfo != undefined) {
    $(objParams.toggleclassinfo + objParams.specval).each(function () {
      $(this).toggleClass(objParams.toggleclassinfoclassname);
      
      const isVisible = $(this).hasClass(objParams.toggleclassinfoclassname);
      const f = isVisible ? "showurl" : "hideurl";
      processCustomRedirect(obj, objParams, f);
    });
  }

  if (objParams.removeclassinfo != undefined) {
    $(objParams.removeclassinfo + objParams.specval).each(function () {
      $(this).toggleClass(objParams.removeclassinfoclassname);

      processCustomRedirect(obj, objParams, "hideurl");
    });
  }

  if (objParams.changeattr != undefined) {
    
    var t = objParams.changeattr.split(" ");

    for (var i in t) {
      var c = t[i].split("|");
      if (c.length < 2) continue;
      var o = $(c[0]);
      if (o == undefined) continue;
      
      var a = c[1];
      if (a == undefined) continue;
      
      var vs = c.length > 2 ? c[2] : "";
      var vh = c.length > 3 ? c[3] : "";
      
      $(c[0]).each(function () {
        if (ischecked) {
          $(this).attr(a, vs);
        } else {
          $(this).attr(a, vh);
        }
      });
    }
  }

  if (objParams.removeattr != undefined) {
    var t = objParams.removeattr.split(" ");

    for (var i in t) {
      var c = t[i].split("|");
      if (c.length < 2) continue;
      var o = $(c[0]);
      if (o == undefined) continue;

      var a = c[1];
      if (a == undefined) continue;

      $(c[0]).each(function () {
        $(this).removeAttr(a);
      });
    }
  }

  if (objParams.hideinfo != undefined) {
    $(objParams.hideinfo).each(function () {
      if (ischecked) {
        $(this).hide();
        processCustomRedirect(obj, objParams, "hideurl");
      } else {
        $(this).show();
        processCustomRedirect(obj, objParams, "showurl");
      }

      if (objParams.classshow != undefined) {
        if (!ischecked)
          classobj.addClass(objParams.classshow);
        else classobj.removeClass(objParams.classshow);
      }
      if (objParams.classshide != undefined) {
        if (ischecked)
          classobj.addClass(objParams.classshide);
        else classobj.removeClass(objParams.classshide);
      }
    });
  }

  if (objParams.showinfo != undefined) {
    $(objParams.showinfo).each(function () {
      if (ischecked) {
        $(this).show();
        processCustomRedirect(obj, objParams, "showurl");
      } else if (!objParams.onlyshow) {
        $(this).hide();
        processCustomRedirect(obj, objParams, "hideurl");
      }

      if (objParams.classshow != undefined) {
        if (ischecked)
          classobj.addClass(objParams.classshow);
        else classobj.removeClass(objParams.classshow);
      }

      if (objParams.classshide != undefined) {
        if (!ischecked)
          classobj.addClass(objParams.classshide);
        else classobj.removeClass(objParams.classshide);
      }
    });
  }

  if (objParams.submit != undefined) {
    $(objParams.submit + objParams.specval).each(function () {
      $(this).submit();
    });
  }

  if (objParams.click != undefined) {
    $(objParams.click + objParams.specval).each(function () {
      $(this).click();
    });
  }

  if (objParams.alert != undefined) {
    alert(objParams.alert);
  }
}

function getCheckedValue(obj, defaultValue) {
  if (defaultValue == undefined) defaultValue = 1;

  var tval = obj.attr("data-checked");
  if (tval != undefined) return tval;

  tval = obj.val();
  if (tval != undefined) return tval;

  return defaultValue;
}

function getUnCheckedValue(obj, defaultValue) {
  if (defaultValue == undefined) defaultValue = 0;

  var tval = obj.attr("data-unchecked");
  if (tval != undefined) return tval;

  // tval = obj.val();
  // if (tval != undefined) return tval;

  return defaultValue;
}

function set_jsmover(obj, isshow) {
  if (isshow == undefined) isshow = true;

  var toggleinfo = obj.attr("data-toggleinfo");
  var showinfo = obj.attr("data-showinfo");
  var hideinfo = obj.attr("data-hideinfo");
  var classinfo = obj.attr("data-classinfo");
  var parent = obj.attr("data-parent");

  if (isshow) {
    obj.addClass("js_mover");
    if (toggleinfo != undefined) $(toggleinfo).addClass("js_mover");
    if (showinfo != undefined) $(showinfo).addClass("js_mover");
    if (hideinfo != undefined) $(hideinfo).addClass("js_mover");
    if (classinfo != undefined) $(classinfo).addClass("js_mover");
    if (parent != undefined) $(parent).addClass("js_mover");
  } else {
    obj.removeClass("js_mover");
    if (toggleinfo != undefined) $(toggleinfo).removeClass("js_mover");
    if (showinfo != undefined) $(showinfo).removeClass("js_mover");
    if (hideinfo != undefined) $(hideinfo).removeClass("js_mover");
    if (classinfo != undefined) $(classinfo).removeClass("js_mover");
    if (parent != undefined) $(parent).removeClass("js_mover");
  }
}

// =============================================

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_select").each(function () {
    if ($(this).hasClass("true_js_CA_select")) return;
    var obj = $(this);
    obj.addClass("true_js_CA_select");

    var oneach = obj.attr("data-oneach");

    if (oneach != undefined) {
      var useSelected = $(this).attr("data-useselected");
      var selected = $(this).find(":selected");
      var tval = selected.val();
      if (useSelected != undefined && useSelected) {
        customaction(selected, tval);
      } else {
        customaction($(this), tval);
      }
    }

    obj.off("change").on('change', function () {
      var useSelected = $(this).attr("data-useselected");
      var selected = $(this).find(":selected");
      var tval = selected.val();
      if (useSelected != undefined && useSelected) {
        customaction(selected, tval);
      } else {
        customaction($(this), tval);
      }
    });
  });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_checkbox").each(function () {
    if ($(this).hasClass("true_js_CA_checkbox")) return;
    var obj = $(this);
    obj.addClass("true_js_CA_checkbox");

    var oneach = obj.attr("data-oneach");

    if (oneach != undefined) {
      var tischecked = $(this).is(":checked");
      var tval = tischecked ? getCheckedValue(obj) : getUnCheckedValue(obj);
      customaction($(this), tval, tischecked);
    }

    obj.off("change").on('change', function () {
      var tischecked = $(this).is(":checked");
      var tval = tischecked ? getCheckedValue(obj) : getUnCheckedValue(obj);
      customaction($(this), tval, tischecked);
    });
  });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_each").each(function () {
    if ($(this).hasClass("true")) return;
    $(this).addClass("true");

    var tu = $(this).attr("data-timeout");
    tu = parseInt(tu);

    if (tu != undefined && !isNaN(tu)) {
      var obj = $(this);
      setTimeout(function () {
        customaction(obj);
      }, tu);
    } else {
      customaction($(this));
    }
  });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_checkboxValue")
    .off("change")
    .on('change', function () {
      if ($(this).is(":checked")) {
        customaction($(this), "", true);
      } else {
        customaction($(this), "", false);
      }
    })
    .each(function () {
      if ($(this).hasClass("true")) return;
      $(this).addClass("true");

      var noneach = $(this).attr('data-noneach');
      if (noneach != undefined) return;
        
        if ($(this).is(":checked")) {
          customaction($(this), "", true);
        } else {
          customaction($(this), "", true);
        }
    })
    .off("mouseenter")
    .on('mouseenter', function () {
      set_jsmover($(this));
    })
    .off("mouseleave")
    .on('mouseleave', function () {
      set_jsmover($(this), false);
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_bodyclick")
    .off("click")
    .on('click', function (e) {
      baseClass.bodyClick();
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_click")
    .off("click")
    .on('click', function (e) {
      var sp = $(this).attr("data-stopp");
      if (sp != undefined && sp == "1") e.stopPropagation();

      var pd = $(this).attr("data-prevdef");
      if (pd != undefined && pd == "1") e.preventDefault();

      customaction($(this));
    })
    .off("mouseenter")
    .on('mouseenter', function () {
      set_jsmover($(this));
    })
    .off("mouseleave")
    .on('mouseleave', function () {
      set_jsmover($(this), false);
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_mouse")
    .off("mouseenter")
    .on('mouseenter', function () {
      set_jsmover($(this));
      var sp = $(this).attr("data-stopp");
      if (sp != undefined && sp == "1") e.stopPropagation();

      var pd = $(this).attr("data-prevdef");
      if (pd != undefined && pd == "1") e.preventDefault();

      customaction($(this));
    })
    .off("mouseleave")
    .on('mouseleave', function () {
      set_jsmover($(this), false);
      var sp = $(this).attr("data-stopp");
      if (sp != undefined && sp == "1") e.stopPropagation();

      var pd = $(this).attr("data-prevdef");
      if (pd != undefined && pd == "1") e.preventDefault();

      customaction($(this), null, false);
    });
});

baseClass.OnReadyArrAdd(function () {
  $(".js_CA_enter").on('keyup', function (e) {
    if (e.keyCode == 13) {
      customaction($(this));
    }
  });
});

// ------------------------------------
baseClass.OnReadyArrAdd(function () {
  $(".jsChangeRequest")
    .off("change")
    .on('change', function () {
      var _customaction = $(this).attr("data-customaction");
      if (_customaction != undefined && _customaction == "1") {
        var obj = $(this).find(":selected");
        customaction(obj);
      }

      var usehistory = $(this).attr("data-usehistory");
      var notshowloading = $(this).attr("data-notshowloading");
      $(this)
        .find("option:selected")
        .each(function () {
          var href = $(this).attr("data-href");
          var targetid = $(this).attr("data-targetid");

          if (href == undefined && targetid != undefined) {
            $("#" + targetid).html("");
          }
          if (href == undefined) return;
          if (notshowloading != "1") baseClass.ShowIsLoadingInProgress();

          if (usehistory == "1") {
            baseClass.targetid = targetid;
            if (!baseClass.targetid) baseClass.targetid = "sitecontent";

            var hash = href;
            hash = hash.replace(/^.*#/, "");
            baseClass.goTo(hash);
          } else {
            baseClass.loadDataAjax($(this));
          }
        });
    })
    .each(function () {
      if ($(this).hasClass("true")) return;

      $(this).addClass("true");

      var changeoneach = $(this).attr("data-changeoneach");
      if (changeoneach == "1") $(this).change();

      var remnotshowloading = $(this).attr("data-remnotshowloading");
      if (remnotshowloading == "1") $(this).removeAttr("data-notshowloading");

      var _customaction = $(this).attr("data-customaction");
      if (_customaction != undefined && _customaction == "1") {
        var obj = $(this).find(":selected");
        customaction(obj);
      }
    });
});

// ------------------------------------
baseClass.OnReadyArrAdd(function () {
  $(".jsEachHeader").each(function () {
    if ($(this).hasClass("true")) return;
    $(this).addClass("true");

    baseClass.onLoadProcessHeaderRequest($(this));
  });
});
